export default __webpack_public_path__ + "static/rubicon1-f86b4ba90e44f034d33924b1c11630a8.png";